import { render } from "./HeaderMain.vue?vue&type=template&id=c89ddbd8&scoped=true"
import script from "./HeaderMain.vue?vue&type=script&lang=js"
export * from "./HeaderMain.vue?vue&type=script&lang=js"

import "./HeaderMain.vue?vue&type=style&index=0&id=c89ddbd8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89ddbd8"]])

export default __exports__